import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import s from './SimpleLink.scss';
export const SimpleLink = (_param)=>{
    var { className, children, size = 'medium', isGreen } = _param, props = _object_without_properties(_param, [
        "className",
        "children",
        "size",
        "isGreen"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread_props(_object_spread({}, props), {
        className: c(className, s['link'], isGreen && s['green'], s[size])
    }), children);
};
SimpleLink.displayName = 'SimpleLink';
export default SimpleLink;
